import type { RootState } from "@/app/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MenuState {
  menuActive: string[];
}

const initialState: MenuState = {
  menuActive: [],
};

const menuSlice = createSlice({
  name: "MENU",
  initialState,
  reducers: {
    changeMenuActive: {
      reducer: (state, action: PayloadAction<string[]>) => {
        const value = action.payload;
        state.menuActive = value;
      },
      prepare: (value: string[]) => ({
        payload: value,
      }),
    },
  },
});

export const menuAction = menuSlice.actions;

export default menuSlice.reducer;

export const getMenuActive = (state: RootState) => state.menus.menuActive;
